var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"RegisterCardStyle"},[_c('SuccessBase',{attrs:{"title":_vm.$t('common.common_password-reset')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }